<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-main">
      <div class="navbar-brand">
        <img id="kfaw-logo" src="@/assets/kfaw-logo.jpg" alt="Keelung for a Walk" />
      </div>
      <div class="navbar-end">
        <a v-if="$i18n.locale !== 'en'" @click="changeLanguage" class="navbar-item"> EN </a>
        <a v-if="$i18n.locale !== 'zh'" @click="changeLanguage" class="navbar-item"> 中文 </a>
        <a v-if="isOnHome" @click="admin" class="navbar-item home-admin-link">{{ $t("home.admin_link") }}</a>
        <a v-else @click="logout" class="navbar-item">{{ $t("general.logout") }}</a>
      </div>
    </div>
    <div class="navbar-admin" v-if="isAdminRoute || isMediaUploadRoute">
      <a
        v-if="isAdminRoute"
        @click="() => this.$router.push('/admin/media-upload')"
        class="navbar-item has-text-link"
        >{{ $t("Media Uploader") }}</a
      >
      <a
        v-if="isMediaUploadRoute"
        @click="() => this.$router.push('/admin')"
        class="navbar-item has-text-link"
        >{{ $t("general.admin") }}</a
      >
    </div>
  </nav>
</template>

<script>
import Login from "@/components/Login.vue";
import ClientStorageService from "@/services/client-storage-services";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
    isOnHome() {
      return this.$route?.name === "Home";
    },
    isAdminRoute() {
      console.log(this.$route?.matched)
      if(this.$route?.matched.length >= 2) {
        return this.$route?.matched[1].name === "Admin";
      }
      return false;
    },
    isMediaUploadRoute() {
      return this.$route?.name === "MediaUpload";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      if (this.$router.currentRoute.name !== "Home") {
        this.$router.push("/");
      }
    },
    admin() {
      this.$buefy.modal.open({
        component: Login,
        hasModalCard: true,
        trapFocus: true,
        ariaModal: true,
        ariaRole: "dialog",
      });
    },
    changeLanguage() {
      if (this.$i18n.locale === "zh") {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = "zh";
      }
      ClientStorageService.setLanguageCode(this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.navbar {
  display: block;
  padding-bottom: 2.3rem;
}

#kfaw-logo {
  max-height: 60px;
}

.navbar-main {
  display: flex;
  align-items: center;
}

.navbar-admin,
.navbar-end {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}

.home-admin-link {
  color: #c3c3c3;
}
</style>
